import { BASE_SERVICE_URL } from '../../../lib/constants'
import type SFTP from '../interface/sftpIntegration';

interface InfoIntegration {
    id: number,
    qualifier: string
}
const listIntegrationSftp = async (): Promise<InfoIntegration[]> => {
    try {
        const listResult = await fetch(`/rest/extension?area=INTEGRATION&query=UPLOAD%20SFTP`, {
            credentials: 'same-origin',
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }).then(obj => obj.extensions)
            .then(extensions => extensions.filter(({ active }) => Boolean(active) == true))
            .then(extensions => extensions
                .map(({ id, qualifier }) => ({ id: Number(id), qualifier: String(qualifier) })))
        return listResult

    } catch (error) {
        return []
    }
}



export default listIntegrationSftp